export class SurveyReportChoice {
    label: string;
    data: number[];

    constructor(query: { text: string; cnt: number }) {
        this.label = query.text;
        this.data = [query.cnt];
    }
}
